import { render, staticRenderFns } from "./CostofsalesList.vue?vue&type=template&id=0941bd76&scoped=true"
import script from "./CostofsalesList.vue?vue&type=script&lang=js"
export * from "./CostofsalesList.vue?vue&type=script&lang=js"
import style0 from "./CostofsalesList.vue?vue&type=style&index=0&id=0941bd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0941bd76",
  null
  
)

export default component.exports